/**
 * Purpose:
 * Central layout identifiers used by the app shell resolver.
 * Why:
 * Keeps layout selection explicit and prevents string duplication across
 * route hosts and future user-specific shell implementations.
 */
import { APP_LAYOUTS } from './account-access.constants';

export type AppLayoutType = typeof APP_LAYOUTS[keyof typeof APP_LAYOUTS];

